import { useNewInBoxConditions } from "../../hooks/useNewInBoxConditions";
import GreyBox from "../nonFunctionalComponents/greyBox/GreyBox";
import styles from "./NewInBox.scss";

const NewInBox = () => {
  const shouldShow = useNewInBoxConditions();

  if (!shouldShow) {
    return null;
  }

  return (
    <GreyBox>
      <p className={styles.newInBoxText}>
        <span className={styles.newInBoxTitle}>New In!</span>{" "}
        <span className={styles.newInBoxDescription}>
          ASOS.WORLD members get 24 hours early access to new in items. Be the
          first in line.
        </span>
      </p>
    </GreyBox>
  );
};

export default NewInBox;
